import { Button, Flex, Text } from '@chakra-ui/react';

const Languages = ({ exit }: { exit: () => void }): JSX.Element => {
  return (
    <Flex direction="column" width="100%">
      <Flex
        direction="column"
        bg="custom.levoAlabaster"
        py="61.5px"
        px={6}
        textAlign="center"
      >
        <Text textStyle="heading3" fontWeight="bold" mb={4}>
          Hooray!
        </Text>
        <Text textStyle="heading3" fontWeight="bold">
          Your application
        </Text>
        <Text textStyle="heading3" fontWeight="bold">
          has been submitted
        </Text>
      </Flex>
      <Flex width="100%" justifyContent="space-between" mt={6}>
        <Button
          width="100%"
          height="fit-content"
          bg="custom.levoBlue"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          onClick={exit}
        >
          <Text textStyle="body" fontWeight={700} color="white">
            Done
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default Languages;
